import React from 'react';

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    // Critical: surface component stack in production so we can pinpoint the render path.
    console.error('ErrorBoundary caught error:', error);
    console.error('Component stack:', info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container-xxl flex-grow-1 container-p-y">
          <div className="alert alert-danger">
            Something went wrong while rendering this page. Check the browser console for details.
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
